import React from 'react';
import checkImg from './../../../assets/images/check.png'
import { useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios';
import loadingGIf from './../../../assets/images/loading.gif'
import FoodDeliveryLoader from '../../components/LoadingView/FoodDeliveryLoder';
function SuccessFullyRegistered(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    console.log(searchParams.get('id'));

    const apiAddress = process.env.REACT_APP_SECRET;

    const navigate = useNavigate();

    const [laoding, setLoading] = React.useState(true);
    const [returnUrl, setReturnUrl] = React.useState();
    const [approvalId, setApprovalId] = React.useState();
    React.useEffect(() => {
        var url = apiAddress + "/api/GoTasteUser/" + searchParams.get('id') + "/true"
        axios({
            method: 'post',
            url: url,
        })
            .then(function (response) {
                console.log("res: " + response.data);
                setLoading(false);
                var url = searchParams.get('returnUrl');
                console.log("url: " + url);
                setReturnUrl(url);
                var res = url?.split("=");
                console.log("res: " + res[1]);
                setApprovalId(res[1]);
                // window.location.href = "/";
            })
            .catch(function (error) {
                console.log(error);
            });
    }, [])
    return (
        <div>
            <div style={{ height: "100vh" }}>
                <div className={`${laoding ? "d-none" : "h-100"}`} >
                    <div className='d-flex align-items-center justify-content-center h-100' style={{ flexDirection: "column" }}>
                        <img src={checkImg} alt="" style={{ width: "5rem" }} />
                        <h2>Verification Success</h2>
                        <p className='text-center'>Thank your for your verification. We have successfully verified your account.<br></br>
                            You can now login and order</p>
                        <h6 style={{ cursor: "pointer" }} onClick={() => { window.location.href = searchParams.get('returnUrl') }}>Go to login</h6>
                    </div>
                </div>
                <div className={`${laoding ? "d-flex align-items-center justify-content-center h-100" : "d-none"}`}>
                    <FoodDeliveryLoader/>
                </div>
            </div>
        </div>
    );
}

export default SuccessFullyRegistered;